import { LoadablePaint } from '@confluence/loadable';

export const LazyLoader = LoadablePaint({
	loader: () => import(/* webpackChunkName: "loadable-Loader" */ './Loader'),
});
